module.exports = __webpack_public_path__ + "static/media/open-app.37f9fb7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/user-new/open-app.png
// module id = 772
// module chunks = 0